import { createRoute } from '@tanstack/react-router';
import BookingsPage from '@/features/dashboard/bookings/pages/BookingsPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const bookingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/bookings',
  component: BookingsPage,
  validateSearch: listSearchSchema,
});
